<div>
    <template v-for="action in actions">
        <FormButton
            type="a"
            :label="action.title"
            :attributes="{class:['text-blue', 'btn-link', 'mt-2', 'no-bg' ,'pl-0']}"
            @click="onAction(action.fn)"
        />
    </template>
</div>